import { hasDOM } from '@rebeldotcom/ui'

export const CONSENT_COOKIE = 'privacy_consent'
export const CONSENT_GROUP_COOKIE = 'consent_group'
// CNIL's current best-practice guidance recommends 6 months for consent
// validity
const CONSENT_MAX_AGE = 60 * 60 * 24 * 182 // 6 months

const getCookie = name => {
  if (!hasDOM) return undefined
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`))
  if (!match) return undefined
  try {
    return decodeURIComponent(match[1])
  } catch {
    return undefined
  }
}

const isConsentValue = value => value === 'agreed' || value === 'declined'

export const setConsentCookie = value => {
  if (!hasDOM) return
  document.cookie = `${CONSENT_COOKIE}=${value}; path=/; max-age=${CONSENT_MAX_AGE}; SameSite=Lax`
}

export const getConsentCookie = () => {
  const value = getCookie(CONSENT_COOKIE)
  return isConsentValue(value) ? value : undefined
}

// Set by the rw-web-cloudfront-rewrite-service Lambda@Edge on every response,
// since this static site has no server of its own to read
// CloudFront-Viewer-Country/-Region. Missing cookie (e.g. edge lambda not yet
// deployed) defaults to the safer group, same as rebel-frontend.
//
// 'regulated': visitor is in a jurisdiction with a mandatory opt-in consent
// law (GDPR: EU/EEA/UK, or Quebec's Law 25) - the banner shows and GA stays
// gated until they agree. 'unregulated': everywhere else - GA runs freely,
// no banner.
export const getConsentGroup = () => {
  const value = getCookie(CONSENT_GROUP_COOKIE)
  return value === 'unregulated' ? 'unregulated' : 'regulated'
}
